export function getToastedMessageFunction(toasted, type) {
  if (type === 'info') 
    return toasted.info;
  else if (type === 'success') 
    return toasted.success;
  else if (type === 'warning') 
    return toasted.warning;
  return toasted.error;
}

export function showValidationErrorsAsToasted(toasted, errors, type = 'error') {
  const toastedMessage = getToastedMessageFunction(toasted, type);
  for (let key in errors) {
    if (errors.hasOwnProperty(key)) {
      errors[key].forEach((err) => {
        toastedMessage(`${key}: ${err}`, {
          duration: 3000,
        });
      });
    }
  }
}

export function showValidationErrorArrayAsToasted(toasted, errors, type = 'error') {
  const toastedMessage = getToastedMessageFunction(toasted, type);
  if (Array.isArray(errors)) {
    errors.forEach((error) => {
      if (error.field && error.message) {
        toastedMessage(`${error.field}: ${error.message}`, {
          duration: 3000,
        });
      } else {
        toastedMessage(`${error}`, {
          duration: 3000,
        });
      }
    });
  }
}

function defaultErrorHandler(response, toasted, type = 'error') {
  const toastedMessage = getToastedMessageFunction(toasted, type);
  process.env.NODE_ENV !== 'production' && console.error(response);
  toastedMessage('Some error occurred', {
    duration: 3000,
  });
}

export function handleServerErrorWithValidation(
  error,
  toasted,
  toastedOptions = { duration: 3000 },
  type = 'error'
) {
  const toastedMessage = getToastedMessageFunction(toasted, type);

  if (!error || !error.response || !error.response.data) {
    defaultErrorHandler(error, toasted, type);
  } else if (error.response.data.hasOwnProperty('errors')) {
    if (Array.isArray(error.response.data.errors)) {
      showValidationErrorArrayAsToasted(toasted, error.response.data.errors, type);
    } else if (Object.keys(error.response.data.errors).length > 0) {
      showValidationErrorsAsToasted(toasted, error.response.data.errors, type);
    }
  } else if (error.response.status === 400 && error.response.data.message) {
    toastedMessage(error.response.data.message, toastedOptions);
  } else {
    defaultErrorHandler(error, toasted, type);
  }
}

export function getMessageError (error) {
  if (!error || !error.response || !error.response.data) {
    process.env.NODE_ENV !== 'production' && console.error(error);
    return 'Some error occurred';
  } else if (error.response.data.hasOwnProperty('errors')) {
    if (Array.isArray(error.response.data.errors)) {
      const errors = error.response.data.errors;
      if (Array.isArray(errors)) {
        return errors.map((error) => error.field && error.message 
          ? `${error.field}: ${error.message}`
          : error
        ).join(', ');
      }
    } else if (Object.keys(error.response.data.errors).length > 0) {
      let message = '';
      for (let key in error.response.data.errors) {
        if (error.response.data.errors.hasOwnProperty(key)) {
          error.response.data.errors[key].forEach((err) => {
            message += `${key}: ${err}, `;
          });
        }
      }
      return message;
    }
  } else if (error.response.status === 400 && error.response.data.message) {
    return error.response.data.message;
  } else {
    return 'Some error occurred';
  }
}
